import { ParamsWithPagination } from '@/types/api';

import { CNMCFilters } from '../types';

export const cnmcQueryKeys = {
  all: ['cnms'] as const,
  lists: () => [...cnmcQueryKeys.all, 'list'] as const,
  list: (params?: ParamsWithPagination<CNMCFilters>) => [...cnmcQueryKeys.lists(), params] as const,
  detail: (id: string) => [...cnmcQueryKeys.all, 'detail', id] as const,
};
